import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { SegmentFilesSectionComponent } from '../segment-files-section/segment-files-section.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { FormsModule } from '@angular/forms';

@Component({
	selector: 'app-segment-files-dialog',
	standalone: true,
	imports: [SegmentFilesSectionComponent, MatDialogModule, MatButtonToggleModule, FormsModule],
	template: `<mat-dialog-content>
		<div class="d-flex justify-content-between align-items-center">
			<p class="py-0 d-flex justify-content-between align-items-center" mat-dialog-title>Pliki</p>
			<mat-button-toggle-group [(ngModel)]="gridStyle">
				<mat-button-toggle value="list"><i class="fa-solid fa-bars"></i></mat-button-toggle>
				<mat-button-toggle value="grid"><i class="fas fa-th"></i></mat-button-toggle>
			</mat-button-toggle-group>
		</div>

		<app-segment-files-section [segmentId]="segmentId" [gridStyle]="gridStyle()"></app-segment-files-section>
	</mat-dialog-content>`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SegmentFilesDialogComponent {
	readonly segmentId = inject<number>(MAT_DIALOG_DATA);
	readonly gridStyle = signal<'list' | 'grid'>('list');
}
